import { render, staticRenderFns } from "./EpicOrder.vue?vue&type=template&id=da4bdf2c&"
import script from "./EpicOrder.vue?vue&type=script&lang=js&"
export * from "./EpicOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports